import { put } from 'redux-saga/effects';
import { FabricationService } from '../../../services/FabricationService';
import {
  loadPieceTypesSuccess,
  loadPieceTypesFailure,
  loadSteelTypesSuccess,
  loadSteelTypesFailure,
  loadSteelTypeDiametersSuccess,
  loadSteelTypeDiametersFailure,
  loadWireTypesSuccess,
  loadWireTypesFailure
} from './actions';
import { IAnnealedWireType, IDiameter, IPieceType, Types } from './types';
import { addToast } from '../toast/actions';
import { EToastTypes } from '../toast/types';
interface ILoadSteelTypeDiamatersParams {
  payload: {
    steelTypeId: number;
  };
  type: Types;
}

interface ILoadWyreTypesParams {
  payload: {
    annealedWireIds: string[];
  };
  type: Types;
}

export function* loadPieceTypesSaga() {
  try {
    const fabricationOrderService = new FabricationService();
    const pieceTypes: IPieceType[] =
      yield fabricationOrderService.getPieceTypes();
    yield put(loadPieceTypesSuccess(pieceTypes));
  } catch (err) {
    console.error('loadPieceTypesSaga', err);
    yield put(
      addToast({
        message: 'Falha ao carregar os tipos de peça.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadPieceTypesFailure(err));
  }
}

export function* loadSteelTypesSaga() {
  try {
    const fabricationOrderService = new FabricationService();
    const pieceTypes: IPieceType[] =
      yield fabricationOrderService.getSteelTypes();
    yield put(loadSteelTypesSuccess(pieceTypes));
  } catch (err) {
    console.error('loadSteelTypesSaga', err);
    yield put(
      addToast({
        message: 'Falha ao carregar os tipos de aço.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadSteelTypesFailure(err));
  }
}

export function* loadSteelTypeDiametersSaga(
  params: ILoadSteelTypeDiamatersParams
) {
  const { steelTypeId } = params.payload;
  try {
    const fabricationOrderService = new FabricationService();
    const diameters: IDiameter[] =
      yield fabricationOrderService.getDiametersFromSteelTypeId(steelTypeId);
    yield put(loadSteelTypeDiametersSuccess(steelTypeId, diameters));
  } catch (err) {
    console.error('loadSteelTypeDiametersSaga', err);
    yield put(
      addToast({
        message: 'Falha ao carregar as bitolas.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadSteelTypeDiametersFailure(steelTypeId, err));
  }
}

export function* loadWireTypesSaga(params: ILoadWyreTypesParams) {
  const { annealedWireIds } = params.payload;
  try {
    const fabricationOrderService = new FabricationService();
    if (annealedWireIds.length > 0) {
      const wireTypes: IAnnealedWireType[] =
        yield fabricationOrderService.getAnnealedWireTypes(annealedWireIds);
      yield put(loadWireTypesSuccess(wireTypes));
    } else {
      yield put(loadWireTypesSuccess([]));
    }
  } catch (err) {
    console.error('loadWireTypesSaga', err);
    yield put(
      addToast({
        message: 'Falha ao carregar os tipos de arame.',
        type: EToastTypes.DANGER
      })
    );
    yield put(loadWireTypesFailure(err));
  }
}
